import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const appointmentApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addappointment: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addAppointment,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getappointments: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `${API_ROUTE.getAppointments}?search=${search}&limit=${limit}&page=${page}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updateappointment: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateAppointment}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deleteappointment: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteAppointment}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getappointmentsbyCalender: builder.query({
      query: ({start_date, end_date}) => {
        return {
          url: `${API_ROUTE.getAppointmentsByCalender}?start_date=${start_date}&end_date=${end_date}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
  }),
});

export const {
  useAddappointmentMutation,
  useGetappointmentsQuery,
  useUpdateappointmentMutation,
  useDeleteappointmentMutation,
  useGetappointmentsbyCalenderQuery,
} = appointmentApi;
